var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-badge', {
    staticClass: "text-uppercase",
    attrs: {
      "variant": _vm.variantLabel
    }
  }, [_vm._v(" " + _vm._s(_vm.textLabel) + " ")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };